import * as Redux from 'redux'
import * as App from './app'
import * as Flash from './components/flash-message'
import * as LeftNav from './components/menu/left-nav'
import * as UserMenu from './components/menu/user-menu'
import * as Config from './config'
import * as AdminReports from './pages/admin-reports'
import * as Excluded from './pages/blacklists'
import * as CommunitiesTableView from './pages/communities'
import * as CommunityConfig from './pages/community-config'
import * as ContentCalendar from './pages/content-calendar'
import * as CreateCommunity from './pages/create-community'
import * as DomainAuthentication from './pages/domain-authentication'
import * as Drops from './pages/drops'
import * as EngagementSummary from './pages/engagement-summary'
import * as Feedback from './pages/feedback'
import * as FilterGroup from './pages/filter-group'
import * as FilterGroups from './pages/filter-groups'
import * as ForgotPassword from './pages/forgot-password'
import * as Home from './pages/home'
import * as Imports from './pages/imports'
import * as ImportErrors from './pages/imports/errors'
import * as IntegrationMappings from './pages/integration-mappings'
import * as IntegrationReports from './pages/integration-reports'
import * as Integrations from './pages/integrations'
import * as IpPools from './pages/ip-pools'
import * as LeadPosts from './pages/lead-posts'
import * as LeadText from './pages/lead-text/reducer'
import * as Login from './pages/login'
import * as MemberDetails from './pages/member-details'
import * as Members from './pages/members'
import * as NewsbriefConfig from './pages/newsbrief'
import * as NewsbriefCounts from './pages/newsbrief-counts'
import * as PreviewNewsbrief from './pages/newsbrief/preview-newsbrief'
import * as OAuthLogin from './pages/oauth-login'
import * as Posts from './pages/posts'
import * as Promotions from './pages/promotions'
import * as Reference from './pages/reference'
import * as ReferralCampaigns from './pages/referral-campaigns'
import * as Reports from './pages/reports'
import * as Analytics from './pages/reports/analytics'
import * as KnowledgeTierReport from './pages/reports/knowledge-tiers/reducer'
import * as OnboardingSessionsReport from './pages/reports/onboarding-sessions/reducer'
import * as ResetPassword from './pages/reset-password'
import * as Schedules from './pages/schedules'
import * as Source from './pages/source-config'
import * as SourceFilters from './pages/source-config/filters'
import * as Sources from './pages/sources'
import * as Training from './pages/training'
import * as UpcomingSchedules from './pages/upcoming-schedules'
import * as UserSettings from './pages/user-settings'
import * as Users from './pages/users'
import * as Router from './router'

export type ApplicationState =
  AdminReports.WrappedState &
  Analytics.WrappedState &
  App.WrappedState &
  CommunityConfig.WrappedState &
  ContentCalendar.WrappedContentCalendarState &
  Config.WrappedState &
  CreateCommunity.WrappedState &
  DomainAuthentication.WrappedState &
  Drops.WrappedState &
  EngagementSummary.WrappedState &
  FilterGroup.WrappedState &
  FilterGroup.WrappedDropdownState &
  FilterGroups.WrappedState &
  Flash.WrappedState &
  ForgotPassword.WrappedState &
  Imports.WrappedState &
  Integrations.WrappedState &
  KnowledgeTierReport.WrappedState &
  LeadPosts.WrappedState &
  LeadText.WrappedState &
  LeftNav.WrappedNavState &
  Login.WrappedState &
  Home.WrappedState &
  Members.WrappedState &
  OAuthLogin.WrappedState &
  Posts.WrappedState &
  PreviewNewsbrief.WrappedState &
  Promotions.WrappedState &
  Reference.WrappedState &
  ReferralCampaigns.WrappedState &
  Reports.WrappedState &
  ResetPassword.WrappedState &
  Router.WrappedState &
  Schedules.WrappedState &
  Source.WrappedState &
  SourceFilters.WrappedState &
  Sources.WrappedState &
  Training.WrappedState &
  UserMenu.WrappedState &
  Excluded.WrappedState

export type Store = Redux.Store<ApplicationState>

export let rootReducer = Redux.combineReducers<ApplicationState>({
  analytics: Analytics.reducer,
  app: App.reducer,
  communities: CommunityConfig.communitiesReducer,
  communitiesView: CommunitiesTableView.reducer,
  communityConfig: CommunityConfig.reducer,
  config: Config.reducer,
  contentCalendar: ContentCalendar.reducer,
  createCommunityForm: CreateCommunity.reducer,
  domainAuthentication: DomainAuthentication.reducer,
  drops: Drops.reducer,
  engagementSummary: EngagementSummary.reducer,
  events: AdminReports.reducer,
  excludedLists: Excluded.reducer,
  feedback: Feedback.reducer,
  filterGroup: FilterGroup.reducer,
  filterGroups: FilterGroups.reducer,
  flash: Flash.reducer,
  forgotPassword: ForgotPassword.reducer,
  home: Home.reducer,
  importErrors: ImportErrors.reducer,
  imports: Imports.reducer,
  integrationMappings: IntegrationMappings.reducer,
  integrationReports: IntegrationReports.reducer,
  integrations: Integrations.reducer,
  ipPools: IpPools.reducer,
  knowledgeTierReports: KnowledgeTierReport.reducer,
  leadPosts: LeadPosts.reducer,
  leadText: LeadText.reducer,
  loginForm: Login.reducer,
  memberDetails: MemberDetails.reducer,
  members: Members.reducer,
  navState: LeftNav.reducer,
  newsbriefConfigs: NewsbriefConfig.reducer,
  newsbriefCounts: NewsbriefCounts.reducer,
  oauthLogin: OAuthLogin.reducer,
  onboardingSessions: OnboardingSessionsReport.reducer,
  posts: Posts.reducer,
  previewNewsbrief: PreviewNewsbrief.reducer,
  promotions: Promotions.reducer,
  referenceData: Reference.reducer,
  referralCampaigns: ReferralCampaigns.reducer,
  reports: Reports.reducer,
  resetPassword: ResetPassword.reducer,
  router: Router.reducer,
  schedules: Schedules.reducer,
  source: Source.reducer,
  sourceFilters: SourceFilters.reducer,
  sources: Sources.reducer,
  training: Training.reducer,
  upcomingSchedules: UpcomingSchedules.reducer,
  userMenu: UserMenu.reducer,
  userSettings: UserSettings.reducer,
  users: Users.reducer,
})



// WEBPACK FOOTER //
// ./src/rootReducer.ts